@if (display) {
  <p-dialog [styleClass]="authenticationService?.user?.fontSize === 'SMALL' ? 'custom-form-small' : (authenticationService?.user?.fontSize === 'MEDIUM' ? 'custom-form-medium' : '')" header="{{title}}" [(visible)]="display" showEffect="fade" [modal]="true"
    [style]="{ width: '24vw' }"
    appendTo="body">
<div [ngClass]="{'custom-form-small': authenticationService?.user?.fontSize === 'SMALL', 'custom-form-medium': authenticationService?.user?.fontSize === 'MEDIUM'}">
    <!-- BODY -->
    <div class="container-md">
      <div class="ui-grid-row">
        <div class="ui-grid-col-12">
          @for (msg of messages; track msg) { <p-message [severity]="msg.severity" [text]="msg.detail"></p-message> }
        </div>
      </div>
      <!-- CODE -->
      <div class="row mt-4">
        <div class="col-12">
          <label for="delegation-code" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.code' | translate}}
                </label>
          <input type="text" id="delegation-code" class="form-control custom-input" [(ngModel)]="entity.code">
        </div>
      </div>
      <!-- NAME -->
      <div class="row mt-4">
        <div class="col-12">
          <label for="delegation-name" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.name' | translate}}
                </label>
          <input type="text" id="delegation-name" class="form-control custom-input" [(ngModel)]="entity.name">
        </div>
      </div>
      <!-- FLEET LEADER -->
      <div class="row mt-4">
        <div class="col-12">
          <label for="delegation-fleetManager" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{ 'tableManagement.delegations.fleetManager' | translate }}
                </label>
          <p-select [options]='fleetUserLeaders' [(ngModel)]='entity.fleetManager' dataKey='id'
              placeholder="{{ 'general.select' | translate }} {{'tableManagement.delegations.fleetManager' | translate}}"
              optionLabel='name' appendTo='body' [filter]="true" filterBy="name,surname1,surname2"
              [style]="{'width':'100%'}" [disabled]='!leadersLoaded'>
              <ng-template pTemplate="selectedItem">
                @if (entity.fleetManager) {
                  <div class="flex align-items-center gap-2">
                    <div> {{ entity.fleetManager?.surname1}} {{entity.fleetManager?.surname2}},
                      {{entity.fleetManager?.name}}
                    </div>
                  </div>
                }
              </ng-template>
              <ng-template let-user pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div> {{user?.surname1}} {{ user?.surname2}}, {{ user?.name}}
                  </div>
                </div>
              </ng-template>
            </p-select>
        </div>
      </div>
      <!-- SERVICE LEADER -->
      <div class="row mt-4">
        <div class="col-12">
          <label for="delegation-serviceManager" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{ 'tableManagement.delegations.serviceManager' | translate }}
                </label>
          <p-select [options]='serviceUserLeaders' [(ngModel)]='entity.serviceManager' dataKey='id'
              placeholder="{{ 'general.select' | translate }} {{'tableManagement.delegations.serviceManager' | translate}}"
              optionLabel='name' appendTo='body' [filter]="true" filterBy="name,surname1,surname2"
              [style]="{'width':'100%'}" [disabled]='!leadersLoaded'>
              <ng-template pTemplate="selectedItem">
                @if (entity.serviceManager) {
                  <div class="flex align-items-center gap-2">
                    <div> {{ entity.serviceManager?.surname1}} {{entity.serviceManager?.surname2}},
                      {{entity.serviceManager?.name}}
                    </div>
                  </div>
                }
              </ng-template>
              <ng-template let-user pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div> {{user?.surname1}} {{ user?.surname2}}, {{ user?.name}}
                  </div>
                </div>
              </ng-template>
            </p-select>
        </div>
      </div>
      <!-- ZONE LEADER -->
      <div class="row mt-4">
        <div class="col-12">
          <label for="delegation-zoneLeader" class="form-label custom-label fw-bold small mb-2 me-2 d-block" i18n>
                    {{'tableManagement.delegations.zoneChief' | translate}}
                </label>
          <p-select [options]='zoneUserLeaders' [(ngModel)]='entity.zoneLeader' dataKey='id'
              placeholder="{{ 'general.select' | translate }} {{'tableManagement.delegations.zoneChief' | translate}}"
              optionLabel='name' appendTo='body' [filter]="true" filterBy="name,surname1,surname2"
              [style]="{'width':'100%'}" [disabled]='!leadersLoaded'>
              <ng-template pTemplate="selectedItem">
                @if (entity.zoneLeader) {
                  <div class="flex align-items-center gap-2">
                    <div> {{ entity.zoneLeader?.surname1}} {{entity.zoneLeader?.surname2}},
                      {{entity.zoneLeader?.name}}
                    </div>
                  </div>
                }
              </ng-template>
              <ng-template let-user pTemplate="item">
                <div class="flex align-items-center gap-2">
                  <div> {{user?.surname1}} {{ user?.surname2}}, {{ user?.name}}
                  </div>
                </div>
              </ng-template>
            </p-select>
        </div>
      </div>
      <!-- ACTIVE -->
      <div class="row mt-4 mb-3">
        <div class="col-12">
          <label for="subdelegation-enabled" class="form-label custom-label fw-bold small mb-2 me-2" i18n>
                    {{'general.active' | translate }}
                </label>
          <input class="form-check-input d-flex justify-content-center align-items-center custom-checkbox"
              type="checkbox" [(ngModel)]="active">
        </div>
      </div>
    </div>
  </div>
<ng-template pTemplate="footer">
      <div class="d-flex justify-content-center bd-highlight">
        <div class="p-2 bd-highlight">
          @if (isNew) {
            <div>
              <button class="btn custom-button" (click)="saveDelegation()" i18n>
                        {{'general.create' | translate}}
                    </button>
            </div>
          }
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="saveDelegation()" i18n>
                        {{'general.save' | translate}}
                    </button>
            </div>
          }
        </div>
        <div class="p-2 bd-highlight">
          @if (!isNew) {
            <div>
              <button class="btn custom-button" (click)="changeStatus(!active)" i18n>
                        {{'general.changeStatus' | translate}}
                    </button>
            </div>
          }
        </div>
      </div>
    </ng-template>
</p-dialog>
}